import { Component } from '@angular/core';

@Component({
    selector: 'gea-svg-error',
    templateUrl: './error.component.html',
    standalone: false
})
export class ErrorComponent {

}
